import { User, Entrepreneur, Investor } from '../types';

// Función para asignar tipo aleatorio
const getRandomUserType = (): 'entrepreneur' | 'investor' => {
  return Math.random() < 0.5 ? 'entrepreneur' : 'investor';
};

// Función para generar edad aleatoria entre 25 y 50
const getRandomAge = (): number => {
  return Math.floor(Math.random() * (50 - 25 + 1)) + 25;
};

// Función para obtener ubicación aleatoria en España
const getRandomLocation = (): string => {
  const locations = [
    'Madrid, España',
    'Barcelona, España',
    'Valencia, España',
    'Sevilla, España',
    'Bilbao, España',
    'Zaragoza, España',
    'Málaga, España',
    'Las Palmas, España',
    'Murcia, España',
    'Alicante, España'
  ];
  return locations[Math.floor(Math.random() * locations.length)];
};

// Nuevos usuarios basados en los profesores de Racks Labs
export const mockTeamMembers: User[] = [
  // Carlos Adams - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '1',
      name: 'Carlos Adams',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fcarlos-adams.jpg&w=3840&q=75'],
      bio: 'Consultor de Negocio y CEO de Racks Labs',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'Racks Labs',
        industry: 'Consultoría de Negocio',
        stage: 'scaling' as const,
        fundingNeeded: '$1M - $5M',
        previousExperience: 'CEO y Consultor de Negocio con amplia experiencia en estrategia empresarial',
        businessModel: 'Consultoría B2B y desarrollo de soluciones tecnológicas',
        teamSize: 50,
        achievements: ['CEO de Racks Labs', 'Experto en Estrategia Empresarial', 'Líder en Transformación Digital']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'vc' as const,
        investmentRange: '$1M - $10M',
        focusIndustries: ['Consultoría', 'SaaS', 'Enterprise Software'],
        investmentStage: ['Series A', 'Series B'],
        portfolioSize: 25,
        notableInvestments: ['TechCorp', 'BusinessFlow', 'ConsultPro'],
        expertise: ['Business Strategy', 'Corporate Development', 'Market Expansion']
      } as Investor;
    }
  })(),

  // Leifer Méndez - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '2',
      name: 'Leifer Méndez',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fleifer-mendez.jpg&w=3840&q=75'],
      bio: 'Programador Senior Full Stack y experto en Inteligencia Artificial',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'AI Solutions Pro',
        industry: 'Inteligencia Artificial',
        stage: 'scaling' as const,
        fundingNeeded: '$2M - $10M',
        previousExperience: 'Programador Senior Full Stack con especialización en IA',
        businessModel: 'Desarrollo de soluciones de IA para empresas',
        teamSize: 15,
        achievements: ['Experto en IA', 'Full Stack Senior', 'Arquitecto de Soluciones']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'angel' as const,
        investmentRange: '$100K - $1M',
        focusIndustries: ['AI/ML', 'Deep Tech', 'SaaS'],
        investmentStage: ['Seed', 'Series A'],
        portfolioSize: 18,
        notableInvestments: ['AIStartup', 'MLPlatform', 'TechFlow'],
        expertise: ['Artificial Intelligence', 'Full Stack Development', 'Technical Architecture']
      } as Investor;
    }
  })(),

  // Bezael Pérez - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '3',
      name: 'Bezael Pérez',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fbezael-perez.jpg&w=3840&q=75'],
      bio: 'DominiCode en redes. Lead Product Software Engineer',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'DominiCode',
        industry: 'Desarrollo de Software',
        stage: 'early-revenue' as const,
        fundingNeeded: '$500K - $2M',
        previousExperience: 'Lead Product Software Engineer con presencia en redes sociales',
        businessModel: 'Educación tecnológica y desarrollo de productos',
        teamSize: 8,
        achievements: ['Lead Product Engineer', 'Influencer Tech', 'Educador Digital']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'angel' as const,
        investmentRange: '$50K - $500K',
        focusIndustries: ['EdTech', 'Developer Tools', 'Social Media'],
        investmentStage: ['Pre-Seed', 'Seed'],
        portfolioSize: 12,
        notableInvestments: ['CodeAcademy', 'DevTools', 'SocialTech'],
        expertise: ['Product Engineering', 'Developer Experience', 'Content Creation']
      } as Investor;
    }
  })(),

  // Mario Álvarez - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '4',
      name: 'Mario Álvarez',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fmario-alvarez.jpg&w=3840&q=75'],
      bio: 'Informático especializado en ciberseguridad con amplia experiencia en Linux y Python',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'SecureLinux Solutions',
        industry: 'Ciberseguridad',
        stage: 'mvp' as const,
        fundingNeeded: '$250K - $1M',
        previousExperience: 'Informático especializado en ciberseguridad con amplia experiencia en Linux y Python',
        businessModel: 'Consultoría en ciberseguridad y desarrollo de herramientas',
        teamSize: 5,
        achievements: ['Experto en Ciberseguridad', 'Especialista Linux', 'Desarrollador Python']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'corporate' as const,
        investmentRange: '$500K - $5M',
        focusIndustries: ['Cybersecurity', 'Enterprise Security', 'Linux Solutions'],
        investmentStage: ['Seed', 'Series A'],
        portfolioSize: 15,
        notableInvestments: ['CyberDefense', 'SecureTech', 'LinuxPro'],
        expertise: ['Cybersecurity', 'Linux Systems', 'Python Development']
      } as Investor;
    }
  })(),

  // Manuel Rivera - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '5',
      name: 'Manuel Rivera',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fmanuel-rivera.jpg&w=3840&q=75'],
      bio: 'Senior Full Stack con gran experiencia en desarrollo de software e Inteligencia Artificial',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'AI Solutions Pro',
        industry: 'Inteligencia Artificial',
        stage: 'scaling' as const,
        fundingNeeded: '$1M - $5M',
        previousExperience: 'Senior Full Stack con gran experiencia en desarrollo de software e Inteligencia Artificial',
        businessModel: 'Desarrollo de soluciones de IA empresariales',
        teamSize: 12,
        achievements: ['Senior Full Stack', 'Experto en IA', 'Arquitecto de Software']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'vc' as const,
        investmentRange: '$1M - $10M',
        focusIndustries: ['AI/ML', 'Full Stack Development', 'Enterprise Software'],
        investmentStage: ['Series A', 'Series B'],
        portfolioSize: 22,
        notableInvestments: ['AITech', 'FullStackSolutions', 'SmartSoftware'],
        expertise: ['Full Stack Development', 'Artificial Intelligence', 'Software Architecture']
      } as Investor;
    }
  })(),

  // Yonathan Suárez - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '6',
      name: 'Yonathan Suárez',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fyonathan-suarez.jpg&w=3840&q=75'],
      bio: 'Ingeniero Senior Full Stack y experto en Inteligencia Artificial',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'InnovateTech AI',
        industry: 'Inteligencia Artificial',
        stage: 'early-revenue' as const,
        fundingNeeded: '$750K - $3M',
        previousExperience: 'Ingeniero Senior Full Stack y experto en Inteligencia Artificial',
        businessModel: 'Plataforma de IA para automatización empresarial',
        teamSize: 10,
        achievements: ['Ingeniero Senior', 'Experto en IA', 'Innovador Tecnológico']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'angel' as const,
        investmentRange: '$100K - $1M',
        focusIndustries: ['AI/ML', 'Engineering', 'Automation'],
        investmentStage: ['Seed', 'Series A'],
        portfolioSize: 16,
        notableInvestments: ['AutomationAI', 'EngineerTech', 'SmartSystems'],
        expertise: ['Software Engineering', 'Artificial Intelligence', 'System Architecture']
      } as Investor;
    }
  })(),

  // Alicia Grao - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '7',
      name: 'Alicia Grao',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Falicia-grao.jpg&w=3840&q=75'],
      bio: 'Desarrolladora y diseñadora Frontend',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'Design & Code Studio',
        industry: 'Diseño y Desarrollo',
        stage: 'prototype' as const,
        fundingNeeded: '$200K - $500K',
        previousExperience: 'Desarrolladora y diseñadora Frontend con enfoque en UX/UI',
        businessModel: 'Estudio de diseño y desarrollo frontend',
        teamSize: 4,
        achievements: ['Diseñadora Frontend', 'Experta en UX/UI', 'Desarrolladora Creativa']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'angel' as const,
        investmentRange: '$25K - $250K',
        focusIndustries: ['Design Tech', 'Frontend Development', 'UX/UI'],
        investmentStage: ['Pre-Seed', 'Seed'],
        portfolioSize: 8,
        notableInvestments: ['DesignStudio', 'FrontendTools', 'UXPlatform'],
        expertise: ['Frontend Development', 'UX/UI Design', 'Creative Technology']
      } as Investor;
    }
  })(),

  // Miguel Brito - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '8',
      name: 'Miguel Brito',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fmiguel-brito.jpg&w=3840&q=75'],
      bio: 'Desarrollador DevOps y Sistemas de Inteligencia Artificial',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'DevOps AI Systems',
        industry: 'DevOps e IA',
        stage: 'mvp' as const,
        fundingNeeded: '$500K - $2M',
        previousExperience: 'Desarrollador DevOps y Sistemas de Inteligencia Artificial',
        businessModel: 'Automatización DevOps con IA para empresas',
        teamSize: 7,
        achievements: ['Experto DevOps', 'Especialista en IA', 'Automatización de Sistemas']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'corporate' as const,
        investmentRange: '$500K - $3M',
        focusIndustries: ['DevOps', 'AI/ML', 'Infrastructure'],
        investmentStage: ['Seed', 'Series A'],
        portfolioSize: 14,
        notableInvestments: ['DevOpsTech', 'AIInfra', 'CloudSystems'],
        expertise: ['DevOps', 'AI Systems', 'Infrastructure Automation']
      } as Investor;
    }
  })(),

  // Ana Vargas - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '9',
      name: 'Ana Vargas',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fana-vargas.jpg&w=3840&q=75'],
      bio: 'Especialista en ciberseguridad y automatizaciones',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'CyberSec Automation',
        industry: 'Ciberseguridad',
        stage: 'prototype' as const,
        fundingNeeded: '$300K - $1M',
        previousExperience: 'Especialista en ciberseguridad y automatizaciones',
        businessModel: 'Soluciones automatizadas de ciberseguridad',
        teamSize: 6,
        achievements: ['Experta en Ciberseguridad', 'Automatización de Procesos', 'Seguridad Digital']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'vc' as const,
        investmentRange: '$500K - $5M',
        focusIndustries: ['Cybersecurity', 'Automation', 'Security Tech'],
        investmentStage: ['Seed', 'Series A'],
        portfolioSize: 11,
        notableInvestments: ['SecureAuto', 'CyberDefense', 'AutoSecurity'],
        expertise: ['Cybersecurity', 'Process Automation', 'Security Systems']
      } as Investor;
    }
  })(),

  // Thomas O'Neil - Asignado aleatoriamente
  (() => {
    const userType = getRandomUserType();
    const baseUser = {
      id: '10',
      name: 'Thomas O\'Neil',
      age: getRandomAge(),
      location: getRandomLocation(),
      images: ['https://landing-template-eight-drab.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fthomas-oneil.jpg&w=3840&q=75'],
      bio: 'Especialista en OSINT, Red Team, Inteligencia de Ciberamenazas y Hacking Ético',
      userType
    };

    if (userType === 'entrepreneur') {
      return {
        ...baseUser,
        userType: 'entrepreneur' as const,
        company: 'CyberThreat Intelligence',
        industry: 'Ciberseguridad',
        stage: 'early-revenue' as const,
        fundingNeeded: '$1M - $3M',
        previousExperience: 'Especialista en OSINT, Red Team, Inteligencia de Ciberamenazas y Hacking Ético',
        businessModel: 'Consultoría especializada en inteligencia de ciberamenazas',
        teamSize: 9,
        achievements: ['Experto en OSINT', 'Red Team Leader', 'Hacking Ético']
      } as Entrepreneur;
    } else {
      return {
        ...baseUser,
        userType: 'investor' as const,
        investorType: 'corporate' as const,
        investmentRange: '$1M - $10M',
        focusIndustries: ['Cybersecurity', 'Threat Intelligence', 'Ethical Hacking'],
        investmentStage: ['Series A', 'Series B'],
        portfolioSize: 20,
        notableInvestments: ['ThreatIntel', 'CyberDefense', 'EthicalHack'],
        expertise: ['OSINT', 'Red Team Operations', 'Cyber Threat Intelligence']
      } as Investor;
    }
  })()
];

// Usuario actual (se mantiene igual)
export const currentUserData: Entrepreneur = {
  id: 'current-user',
  name: 'Alex Johnson',
  age: 30,
  location: 'Madrid, España',
  userType: 'entrepreneur',
  company: 'TechFlow',
  industry: 'SaaS',
  stage: 'seed',
  fundingNeeded: '$1M - $2M',
  previousExperience: 'Ex-Google Product Manager, 6 años en tech',
  businessModel: 'B2B SaaS para automatización de workflows',
  teamSize: 8,
  bio: 'Construyendo automatización de workflows impulsada por IA para equipos empresariales.',
  images: [
    'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=400&h=600&fit=crop'
  ],
  achievements: ['Ronda Seed: $1.2M recaudados', 'Product Hunt #1', '500+ Clientes Empresariales']
};

// Exportamos la lista de usuarios del equipo